/**
 * TODO: validate the postal code, Postal code should be 4 digit
 * @return True for valid postal code
 */
const validatePostalCode = (postalCode: string) => {
  const regexp = new RegExp(/^\d{4}$/);

  return regexp.test(postalCode);
};

export default validatePostalCode;
